module.exports = __webpack_public_path__ + "static/avatar-c99035c8ff4376bb578c17e597c4baed.jpg";